// JsFromRoutes CacheKey 6a6b077538090f02f7807c11016fa330
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/members/marketplace'),
  show: /* #__PURE__ */ definePathHelper('get', '/members/marketplace/:product_slug'),
  checkout: /* #__PURE__ */ definePathHelper('get', '/members/marketplace/:product_slug/checkout'),
  confirmation: /* #__PURE__ */ definePathHelper('get', '/members/marketplace/orders/:purchase_id/confirmation'),
}
